import MuiGrid, { GridProps as MuiGridProps } from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import React, { forwardRef, FunctionComponent } from "react";
import { SPACING } from "designSystem/theme";

export interface GridProps extends MuiGridProps {
	/** component should take up full height of container */
	fullHeight?: boolean;

	/** spacing for grid (number only) */
	spacing?: number;
};

const Grid: FunctionComponent<GridProps> = forwardRef((props, ref) => {
	const { className, fullHeight, ...otherProps } = props;

	return (
		<MuiGrid
			className={className || ""}
			height={fullHeight ? `calc(100% + ${(props.spacing || 0) * SPACING}px)` : null}
			ref={ref}
			{...otherProps}
		/>
	);
});

export default Grid;